import { render, staticRenderFns } from "./lib.component.vue?vue&type=template&id=6820d460&scoped=true"
import script from "./lib.component.vue?vue&type=script&lang=ts"
export * from "./lib.component.vue?vue&type=script&lang=ts"
import style0 from "./lib.component.vue?vue&type=style&index=0&id=6820d460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6820d460",
  null
  
)

export default component.exports